import React from 'react';
import { motion } from 'framer-motion';
const proof = [{
  value: '2002',
  label: 'Building custom sites since',
  note: 'Two decades of launches, migrations, and rebuilds'
}, {
  value: '1000+',
  label: 'Websites launched',
  note: 'Custom builds and redesigns, never a stock theme'
}, {
  value: '100+',
  label: 'API integrations built',
  note: 'CRMs, accounting, scheduling, inventory, internal tools'
}, {
  value: '0%',
  label: 'Transaction fees from us',
  note: 'On every ecommerce store we build and maintain'
}];
export function ProofBand() {
  return <section aria-label="Proof points" className="relative overflow-hidden bg-navy-900" data-id="element-262" data-mp="34z77a8yqwz6c">
      <div className="absolute inset-0 hatch opacity-[0.35]" aria-hidden="true" data-id="element-263" data-mp="391lpqryi5wx3" />
      <div className="absolute inset-y-0 left-1/2 hidden w-px -translate-x-1/2 bg-white/5 lg:block" aria-hidden="true" data-id="element-264" data-mp="3dueqz5urin4f" />

      <div className="relative mx-auto grid max-w-8xl grid-cols-1 gap-px bg-white/[0.07] sm:grid-cols-2 lg:grid-cols-4" data-id="element-265" data-mp="2h9mmrlmy1tuy">
        {proof.map((p, i) => <motion.div key={p.label} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        delay: i * 0.07,
        duration: 0.45
      }} className="group relative overflow-hidden bg-navy-900 px-5 py-9 sm:px-8 lg:py-12" data-id="element-266" data-mp="qeairnbvjkum" data-mpi={i}>
            <span className="pointer-events-none absolute -right-2 -top-6 select-none font-display text-[6rem] font-extrabold leading-none text-white/[0.03]" aria-hidden="true" data-id="element-267" data-mp="bna5n506n2s5">
              0{i + 1}
            </span>
            <p className={`font-display text-[2.1rem] font-extrabold leading-none tracking-[-0.02em] lg:text-[2.6rem] ${i === 3 ? 'text-forge-green' : i === 1 ? 'text-forge-cyan' : 'text-forge-orange'}`} data-id="element-268" data-mp="3tv9g2z4bt5r1">
              {p.value}
            </p>
            <p className="mt-3 text-[14px] font-bold text-white" data-id="element-269" data-mp="1n4t4yman6llf">{p.label}</p>
            <p className="mt-1.5 max-w-[22ch] text-[12.5px] leading-relaxed text-mist-400" data-id="element-270" data-mp="3hjgrk4hhi3v2">{p.note}</p>
            <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-forge-orange transition-all duration-500 group-hover:w-full" aria-hidden="true" data-id="element-271" data-mp="3mc9uqnxb1451" />
          </motion.div>)}
      </div>
    </section>;
}